import styled from 'styled-components';

export const ReviewPageBgWrapper = styled.section`
  background: #2276e3;
  width: 100%;
  height: 19rem;
  display: flex;
`;
export const HeaderWrapper = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  position: relative;
`;
export const PageHeader = styled.header(
  props => `
    font-size: 2.2rem;
    color: white;
    font-weight: bold;
    font-family:${props.theme.font.fontFamily};
    padding: 2rem 0;
`,
);
export const BookingHeader = styled(PageHeader)`
  span {
    font-weight: normal;
  }
`;
export const HeaderInfo = styled.div(
  props => `
    padding-left: 1rem;
    padding-top: 9.5rem;
    display: flex;
    span {
        font-family:${props.theme.font.fontFamily};
        color: white;
        font-size: 1.6rem;
        font-weight: bold;
        padding-left: 1rem;
    }
`,
);

export const PageWrapper = styled.section`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: -5rem;
`;
export const LeftWrapper = styled.section`
  width: 100%;
  max-width: 793px;
`;
export const RightWrapper = styled.section`
  width: 100%;
  max-width: 387px;
  position: sticky;
  align-self: flex-start;
  top: 0;
`;
export const ReviewCardWrap = styled.section`
  margin-top: 1.5rem;
`;
export const ReviewCard = styled.section`
  background: white;
  border-radius: 0.4rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

export const TabContent = styled.div`
  transition: all 0.35s;
`;

export const TabLabel = styled.label(
  props => `
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 2rem;
      cursor: pointer;
      align-items: center;
      &::after {
          content: '\\276F';
          width: 2em;
          height: 2em;
          text-align: center;
          transform: rotate(90deg);
          -webkit-transition: all .35s;
          transition: all .35s;
          color: #898b91;
          font-size: 1.2rem;
          padding-top:0.5rem;
          background: #eef4fd;
          border-radius: 50%;
          margin-top: 0.3rem;
      }
      span {
          color: #141823;
          font-size: 2.2rem;
          font-weight: bold;
          font-family:${props.theme.font.fontFamily};
          text-transform: uppercase;
          
      }
  `,
);

export const HeaderInput = styled.input`
  position: absolute;
  z-index: -1;
  &:checked + ${TabLabel}::after {
    transform: rotate(-90deg);
  }
  &:checked ~ ${TabContent} {
    max-height: fit-content;
  }
`;

export const PayButton = styled.button(
  props => `
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          border-radius: 0.6rem;
          background: #ff6d38;
          font-size: 1.8rem;
          font-weight: bold;
          font-family: ${props.theme.font.fontFamily};
          padding: 1.5rem 2rem;
          margin-top: 1rem;
          border: 0;
          outline: 0;
          cursor: pointer;
          margin-bottom: 1.5rem;
      `,
);

export const UserChoice = styled.section`
  border-radius: 0.4rem;
  background-color: #e9f6ea;
  padding: 2rem;
  margin-top: 1.5rem;
`;
export const UserChoiceTxt = styled.p`
  font-size: 1.4rem;
  color: #2bac36;
  padding-bottom: 1rem;
`;
export const UserChoiceTag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const UserTag = styled.div`
  padding: 0.2rem 0.5rem;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 0.5rem;
  background-image: linear-gradient(78deg, #00c57e, #18a160);
  span {
    color: white;
    font-weight: bold;
    font-size: 1.1rem;
    padding-left: 0.1rem;
  }
`;

export const PaymentCard = styled.section`
  background: white;
  border-radius: 0.4rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

export const PaymentTabContent = styled.div`
  transition: all 0.35s;
`;

export const PaymentTabLabel = styled.label(
  props => `
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 2rem;
      cursor: pointer;
      align-items: center;
      span {
          color: #141823;
          font-size: 2.2rem;
          font-weight: bold;
          font-family:${props.theme.font.fontFamily};
          text-transform: uppercase;
          
      }
  `,
);

export const paymentHeaderInput = styled.input`
  position: absolute;
  z-index: -1;
  &:checked ~ ${TabContent} {
    max-height: fit-content;
  }
`;



export const GoTribeSideStripComponent = styled.div`
  margin-bottom: 10px;
  h5{
    color:rgb(34,34,34);
  }
`    

export const GoTribeReviewComponent = styled.div`
  margin-bottom: 15px;
  margin-top: 20px;
  a:hover{
    color:rgb(34, 118, 227);
  }
`    